module.exports = __webpack_public_path__ + "static/media/crownOff_326.fe2146f5.png";